import { chatQueryKeys as e } from "../hooks/useChatQueryKeys.mjs";
import { adminSupportChatApi as t } from "@maat/api-chat";
//#region src/transport/adminSupportChatTransport.ts
var n = (n) => ({
	api: t,
	keys: {
		messages: e.adminSupportMessages,
		internalNotes: e.adminSupportNotes,
		summary: e.adminSupportSummary,
		conversations: null,
		unread: () => e.adminSupportUnread()
	},
	identity: n
});
//#endregion
export { n as createAdminSupportChatTransport };
